import { resolveItemFromRow } from '@workbuddy/entities/shared/items';

/** The JobItem board's record scope — where one row's item sits inside the parent-shaped job. */
const JOB_ITEM_SCOPE = 'workOrders.codes';

/**
 * The item inside one board row. Returns `any` because callers read both item and job-shaped fields
 * off it — notably the stage id at `row.workOrders._id`, which only arrives because the stage
 * metadata annotates `_id`: the server's projection allow-list is built from annotated fields, so an
 * unannotated path is dropped even when the view lists it.
 */
export function resolveItemRecord(row: any): any {

  return resolveItemFromRow(row, JOB_ITEM_SCOPE);
}
